import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import { GetSecrets } from './logkey';

const browserHistory = createBrowserHistory({ basename: '' });
const reactPlugin = new ReactPlugin();

// Initialize as null or a dummy object if needed to prevent crash on immediate access
let appInsights = null;

const initializeAppInsights = async () => {
    // If already initialized, return existing instance
    if (appInsights) return appInsights;

    try {
        const key = await GetSecrets.getloggingkey();
        
        if (!key) {
            console.warn('Logging key not available, Application Insights not initialized');
            return null;
        }
        
        appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: key,
                extensions: [reactPlugin],
                extensionConfig: {
                    [reactPlugin.identifier]: { history: browserHistory },
                },
                enableAutoRouteTracking: true,
                disableFetchTracking: false,
            },
        });
        appInsights?.loadAppInsights();
        return appInsights;
    } catch (error) {
        console.error('Failed to initialize Application Insights:', error);
        return null; // Return null on failure so app doesn't crash
    }
};

export { reactPlugin, appInsights, initializeAppInsights };
